import React from 'react';
import { useNavigate } from 'react-router-dom';
import './casestudy.css';
import dumpster from "./dumpster.jpg";
import ecommerce from "./e-commerce.png";
import fence from "./fence.jpg";
import hvac from "./hvac.jpg";
import lawyers from "./lawyers.jpg";
import restaurant from "./restaurant.png";

const Casestudy = () => {
  const navigate = useNavigate();

  const caseStudies = [
    {
      title: 'HVAC Company Boosts Leads by 150%',
      description: 'A local HVAC company struggled with limited visibility on Google Maps, leading to fewer inbound leads and calls. Our targeted local SEO strategies improved their rankings, resulting in a 150% increase in leads.',
      image: hvac,
    },
    {
      title: 'Dumpster Rental Service Doubles Inbound Leads',
      description: 'A dumpster rental service aimed to create a consistent flow of leads through local Google Search Ads and improve their Google Maps ranking using Local SEO strategies. Our approach led to a significant increase in inbound leads.',
      image: dumpster,
    },
    {
      title: 'Fencing Company Achieves #1 Google Ranking',
      description: 'A local fencing & decking company aimed to rank #1 for "Fencing Salem" on Google and increase leads through targeted Google Ads. Our strategies helped them achieve top rankings and a surge in inquiries.',
      image: fence,
    },
    {
      title: 'E-Commerce Store Revenue Growth by 200%',
      description: 'An online retail store needed a boost in traffic and conversions. Our SEO and PPC campaigns resulted in a 200% increase in sales.',
      image: ecommerce,
    },
    {
      title: 'Law Firm Generates 3x More Leads',
      description: 'A law firm sought to generate more leads through organic search. Our content strategy and local SEO doubled their organic traffic.',
      image: lawyers,
    },
    {
        title: 'Restaurant Increases Bookings by 75%',
        description: 'A restaurant struggling with online visibility leveraged our SEO and social media strategies, increasing reservations by 75%.',
        image: restaurant,
    }
  ];

  const testimonials = [
    {
      quote: 'The team transformed our online presence, leading to a significant increase in leads. Their expertise is unmatched!',
      author: 'Alex P., Business Owner'
    },
    {
      quote: 'Our website traffic and customer engagement have soared since partnering with them. Highly recommend their services!',
      author: 'Jamie L., Marketing Director'
    },
    {
      quote: 'From SEO to paid ads, they handled everything and delivered beyond our expectations. Fantastic results!',
      author: 'Samantha K., E-commerce Store Owner'
    },
    {
      quote: 'Thanks to their targeted marketing strategies, we went from struggling to being fully booked every weekend!',
      author: 'Daniel R., Restaurant Owner'
    }
  ];

  return (
    <div className="case-study-container">
      <header className="hero">
        <h1>Our Success Stories</h1>
        <p>Discover how we've helped businesses like yours achieve remarkable growth through our services.</p>
      </header>

      <section className="case-studies">
        {caseStudies.map((study, index) => (
          <div className="case-card" key={index}>
            <img src={study.image} alt={study.title} />
            <h2>{study.title}</h2>
            <p>{study.description}</p>
          </div>
        ))}
      </section>

      <section className="testimonials">
        <h2>What Our Clients Say</h2>
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-card" key={index}>
            <p>"{testimonial.quote}"</p>
            <span>- {testimonial.author}</span>
          </div>
        ))}
      </section>

      <footer className="cta">
        <h2>Ready to Transform Your Business?</h2>
        <p>Contact us today to start your journey towards online success.</p>
        <button onClick={() => navigate('/contact')}>Contact Us</button>
      </footer>
    </div>
  );
};

export default Casestudy;
